import usePostOffices from './usePostOffices';

export default usePostOffices;
